<!-- Dashboard start -->
<!-- END: Left Aside -->

<ngx-spinner
  bdColor="rgba(75, 55, 100, 0.5)"
  size="large"
  color="#fff"
  type="line-scale-pulse-out">
    <span class="chevron left"></span>
    <span class="chevron right"></span>
</ngx-spinner>

<div class="m-grid__item m-grid__item--fluid m-wrapper" *ngIf="form">
  <!--MAIN-->
  <div class="m-content">
    <!--begin::Portlet-->
    <form
        [formGroup]="form"
        *ngIf="form"
        class="m-form m-form--fit m-form--label-align-right"
      >
    <div class="m-portlet">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text" *ngIf="!merchantId">
              ONLINE SALES WEBSITE
            </h3>
          </div>
        </div>
      </div>

      <!--begin::Form-->
        <div class="m-portlet__body">
          <div class="m-form__section m-form__section--first">

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                <img
                  *ngIf="!hasUpdatePPWSiteName"
                  tooltip="You do not have the required permissions to change the PPW site name."
                  src="../../../../assets/app/media/img/icons/warning.svg"
                  class="tooltip-icon"
                  style="width: 35px;"
                />
                Website Host Name:
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="name"
                  type="text"
                  id="name"
                  [ignoreWhiteSpace]
                  class="form-control m-input"
                  placeholder=""
                  (input)="checkHostnameAvailability()"
                  (blur)="generateBaseQRCode()"
                />
                <i *ngIf="availableHostname && formControls('name').value !== ''" class="tooltip-icon accepted-icon note-icon-menu-check" tooltip="That hostname is available"></i>
                <i *ngIf="!availableHostname && formControls('name').value !== ''" class="tooltip-icon danger-icon flaticon-exclamation-2" tooltip="That hostname is already taken."></i>
                <span *ngIf="form.controls.name.value && form.controls.name.value != ''" style="font-weight: 800;" class="m-form__help">
                    https://{{form.controls.name.value + environment}}pledgeperwin.com
                </span>
                <app-validation-display
                  [control]="form.controls.name"
                  errorMessage="Please provide a valid website host name. The name must not contain upper case letters or special characters other than '-' or '.'"
                ></app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Primary Color:
              </label>
              <div class="col-lg-2">
                <input
                  formControlName="primaryColor"
                  type="text"
                  class="form-control m-input"
                  [colorPicker]="formControls('primaryColor').value"
                  [cpDisableInput]="true"
                  [cpPosition]="right"
                  [cpAlphaChannel]="'disabled'"
                  [value]="formControls('primaryColor').value"
                  [style.background]="formControls('primaryColor').value"
                  (colorPickerChange)="formControls('primaryColor').setValue($event)"
                />
                <app-validation-display [control]="form.controls.primaryColor" errorMessage="Please specify valid color"></app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Secondary Color:
              </label>
              <div class="col-lg-2">
                <input
                  formControlName="secondaryColor"
                  type="text"
                  class="form-control m-input"
                  [colorPicker]="formControls('secondaryColor').value"
                  [cpDisableInput]="true"
                  [cpPosition]="right"
                  [cpAlphaChannel]="'disabled'"
                  [value]="formControls('secondaryColor').value"
                  [style.background]="formControls('secondaryColor').value"
                  (colorPickerChange)="formControls('secondaryColor').setValue($event)"
                />
                <app-validation-display [control]="form.controls.secondaryColor" errorMessage="Please specify valid color"></app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Legal PDF:
              </label>
              <div class="col-lg-4" style="display: flex;">
                <div style="display: flex; flex-direction: column;">
                  <input
                      type="file"
                      (change)="savePdf($event.target.files[0])"
                      name="file-1[]"
                      id="file-1"
                      class="venue-fileinput"
                      accept="application/pdf"
                    />
                  <a
                    *ngIf="formControls('legalUrl').value !== ''"
                    alt="" [href]="formControls('legalUrl').value"
                    style="display: block;"
                    target="_blank">
                    Legal Specifications
                  </a>
                  <span
                    onselectstart="return false"
                    class="img-text"
                    style="display: block;">
                      Click here to upload a PDF of legal specifications
                  </span>
                  <app-validation-display
                    *ngIf="formControls('legalUrl')?.errors?.required === true"
                    [control]="formControls('legalUrl')"
                    errorMessage="This file is required.">
                  </app-validation-display>
                  <app-validation-display
                    *ngIf="formControls('legalUrl')?.errors?.notPdf === true"
                    [control]="formControls('legalUrl')"
                    errorMessage="Make sure the file is a PDF.">
                  </app-validation-display>
                </div>
                <a *ngIf="formControls('legalUrl').value !== ''" (click)="deletePdf()" href="#" class="m-menu__link" style="display: inline; text-decoration: none; margin-top: 5px; position: relative; left: 8px;">
                  <i class="m-menu__link-icon flaticon-cancel"></i>
                </a>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Banner Image:
              </label>
              <div class="col-lg-4">
                <input
                    type="file"
                    (change)="verifyImageDimensions($event.target.files[0], 'banner')"
                    name="file-1[]"
                    id="file-1"
                    class="venue-fileinput"
                    accept="image/*"
                  />
                <img
                  *ngIf="formControls('bannerUrl').value !== ''"
                  alt="" [src]="formControls('bannerUrl').value" style="display: block;">
                <span
                  onselectstart="return false"
                  class="img-text"
                  style="display: block;"
                  >
                    Click here to upload an image of your banner. Image must have a minimum width of 1366px, minimum height of 768px, and an aspect ratio of 16:9.
                </span>
                <app-validation-display
                  *ngIf="formControls('bannerUrl')?.errors?.required === true"
                  [control]="formControls('bannerUrl')"
                  errorMessage="This file is required.">
                </app-validation-display>
                <app-validation-display
                  *ngIf="formControls('bannerUrl')?.errors?.incorrectDimensions === true"
                  [control]="formControls('bannerUrl')"
                  errorMessage="Make sure your file is an image, has a height greater than or equal to 768px, a width greater than or equal to 1366, and an aspect ratio of 16:9.">
                </app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Logo Image:
              </label>
              <div class="col-lg-4">
                <input
                    type="file"
                    (change)="verifyImageDimensions($event.target.files[0], 'logo')"
                    name="file-1[]"
                    id="file-1"
                    class="venue-fileinput"
                    accept="image/png"
                  />
                <img
                  *ngIf="formControls('logoUrl').value !== ''"
                  alt="" [src]="formControls('logoUrl').value" style="display: block;">
                <span
                  onselectstart="return false"
                  class="img-text"
                  style="display: block;"
                  >
                    Click here to upload an image of your logo. Image must be a PNG, have a minimum width of 60px, and minimum height of 44px.
                </span>
                <app-validation-display
                  *ngIf="formControls('logoUrl')?.errors?.required === true"
                  [control]="formControls('logoUrl')"
                  errorMessage="This file is required.">
                </app-validation-display>
                <app-validation-display
                  *ngIf="formControls('logoUrl')?.errors?.incorrectDimensions === true"
                  [control]="formControls('logoUrl')"
                  errorMessage="Make sure your file is a PNG, has a height greater than or equal to 44px, and a width greater than or equal to 60px.">
                </app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Advertisement Image:
              </label>
              <div class="col-lg-4">
                <input
                    type="file"
                    (change)="verifyImageDimensions($event.target.files[0], 'sponsor')"
                    name="file-1[]"
                    id="file-1"
                    class="venue-fileinput"
                    accept="image/*"
                  />
                <img
                  *ngIf="formControls('sponsorUrl').value !== ''"
                  alt="" [src]="formControls('sponsorUrl').value" style="display: block;">
                <span
                  onselectstart="return false"
                  class="img-text"
                  style="display: block;"
                  >
                    Click here to upload an image of your Sponsor. Image must have a minimum width of 1080 px and a minimum height of 318px.
                </span>
                <app-validation-display
                  *ngIf="formControls('sponsorUrl')?.errors?.incorrectDimensions === true"
                  [control]="formControls('sponsorUrl')"
                  errorMessage="Make sure your file is an image, has a height greater than or equal to 318px, and a width greater than or equal to 1080px.">
                </app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Advertisement Sponsor Name:
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="advertisementName"
                  type="text"
                  class="form-control m-input"
                  placeholder=""
                />
                <app-validation-display
                  [control]="formControls('advertisementName')"
                  errorMessage="Invalid text.">
                </app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Advertisement Text:
              </label>
              <div class="col-lg-4">
                <textarea
                    formControlName="advertisementText"
                    class="form-control m-input"
                    rows="5"
                  ></textarea>
                <app-validation-display
                  [control]="formControls('advertisementText')"
                  errorMessage="Invalid text.">
                </app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Advertisement Url:
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="advertisementUrl"
                  type="text"
                  [ignoreWhiteSpace]
                  class="form-control m-input"
                  placeholder=""
                  (blur)="validateUrl()"
                />
                <app-validation-display
                  [control]="formControls('advertisementUrl')"
                  errorMessage="Please provide a valid URL."
                ></app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
              FAQs:
              </label>
              <div class="col-lg-4">
                <div
                  formArrayName="faq"
                  *ngFor="let t of formControls('faq').controls; let i = index"
                  >
                  <div *ngIf="t" [formGroupName]="i" class="faq" [ngStyle]="{'padding-top': i !== 0 ? '15px' : '0'}">
                    <div>
                      <textarea
                        formControlName="head"
                        type="text"
                        class="form-control m-input"
                        placeholder="Question"
                        rows="2"
                        ></textarea>
                      <textarea
                        formControlName="paragraph"
                        type=""
                        class="form-control m-input"
                        placeholder="Answer"
                        rows="5"
                      ></textarea>
                    </div>
                    <a *ngIf="i > 2" (click)="deleteFaqItem(i)" href="#" class="m-menu__link faq-delete">
                      <i class="m-menu__link-icon flaticon-cancel"></i>
                    </a>
                  </div>
                <app-validation-display
                  class="validation-display"
                  [control]="t.controls.head"
                  [errorMessage]="i === 0 ? 'At least one FAQ is required.' : 'Please enter a valid question.'"
                  ></app-validation-display>
                <app-validation-display
                  class="validation-display"
                  [control]="t.controls.paragraph"
                  [errorMessage]="i === 0 ? 'At least one FAQ is required.' : 'Please enter a valid answer.'"
                  ></app-validation-display>
              </div>
            </div>
            </div>
            <div class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label"></label>
            <div class="col-lg-3">
              <a (click)="newFaqItem()" style="text-decoration: none;" href="#">+ New Faq</a>
            </div>
            </div>
          </div>
        </div>


    </div>

    <div class="m-portlet" style="position: relative;">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text">
              Admin Support
            </h3>
          </div>
        </div>
      </div>

      <div class="m-portlet__body">
        <div class="m-form__section m-form__section--first">

          <div
            class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label"> Support Email Addresses: </label>
            <div class="col-lg-6">
              <div style="display:flex;align-items:center;">
                <ng-select
                  [addTag]="true"
                  [multiple]="true"
                  [hideSelected]="true"
                  formControlName="supportAddresses"
                  bindLabel="label"
                >
                </ng-select>
                <img
                  src="../../assets/app/media/img/icons/info-icon.png"
                  class="tooltip-icon"
                  tooltip="Reports on declined charges will be sent to these addresses."
                />
              </div>
              <span
                class="m-form__help"
                style="color:red;"
                *ngIf="!form.controls.supportAddresses.valid && (form.controls.supportAddresses.dirty || form.controls.supportAddresses.touched)"
              >
                Please remove any invalid or duplicate emails.
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="m-portlet" style="position: relative;">

      <ngx-spinner
        name="qrSpinner"
        [fullScreen]="false"
        bdColor="rgba(75, 55, 100, 0.5)"
        size="large"
        color="#fff"
        type="line-scale-pulse-out">
          <span class="chevron left"></span>
          <span class="chevron right"></span>
      </ngx-spinner>

      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text">
              Base Site QR Code
            </h3>
          </div>
        </div>
      </div>
      <div class="m-portlet__body">
        <div class="m-form__section m-form__section--first">
          <div class="form-group m-form__group row" style="justify-content: center;">
            <img
              *ngIf="form.get('baseQRUrl').value !== ''"
              tooltip='Right click, then click "save image as..." to download the QR code.'
              width="300"
              height="300"
              [src]="form.get('baseQRUrl').value"/>
          </div>
        </div>
      </div>
    </div>

</form>

    <div class="form-group m-form__group row">
      <div class="col-lg-12">
        <button
          [debounceClick]
          type="submit"
          (click)="save()"
          class="btn btn-primary"
          [disabled]="!hasUpdatePPWSite || generatingQR"
        >
          {{ siteId > 0 ? 'Update' : 'Save' }}
        </button>
        <button
          style="margin-left: 15px;"
          type="submit"
          (click)="handleCancel()"
          class="btn btn-danger"
        >
          Cancel
        </button>
        <div *ngIf="hasValidationErrors && hasUpdatePPWSite">
          <span style="color:red">Please complete the required fields</span>
        </div>
        <div *ngIf="!hasUpdatePPWSite">
          <span style="color:red">You do not have the required permissions to edit your organization's PPW site.</span>
        </div>

      </div>
    </div>
  </div>
</div>
